import React from "react";
import { useNavigate } from "react-router-dom";

const PasswordSuccessful = () => {
  const navigate = useNavigate();

  return (
    <div className={`h-screen overflow-hidden relative`}>
      <div className="flex items-center justify-center h-full bg-no-repeat bg-cover bg-center opacity-95 bg-gradient-to-r from-[rgba(255,235,79,0.5)] to-[rgba(69,160,85,0.5)]">
        <section className="w-full">
          <div className="max-w-sm w-full mx-auto text-center bg-[#FFFFFFE5] rounded-lg drop-shadow-lg px-8 py-12">
            {/* Heading and Message */}
            <div className="mb-8">
              <h1 className="sm:text-3xl text-lg font-opensans font-normal mb-1">
                Reset password
              </h1>
              <p className="text-5xl font-light text-primary_black">
                Successful!
              </p>
            </div>
            <button
              type="submit"
              className="w-full block text-white bg-themeBtn text-center text-base border-2 border-transparent uppercase rounded transition duration-500 py-2 lg:px-7 px-4"
              onClick={() => navigate("/login")}
            >
              login now
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PasswordSuccessful;
